<!doctype html>
<html lang="en">
  <!-- <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
    <link
      href="https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap"
      rel="stylesheet" />
  </head> -->

  <body id="pdf-data" #pdfContent>
    <div class="pdf-content">
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":"auto"}'>
          <img
            alt="Org logo"
            [src]="quickGuideData?.orgLogo"
            style="width: 125px; height: auto; object-fit: contain" />
        </div>
        <div data-pdfmake='{"width":"*", "margin": [10, 0]}'>
          <div class="desc" style="text-align: right">
            {{ quickGuideData?.orgDetail.address }}
          </div>
          <div class="address" style="text-align: right">
            {{ quickGuideData?.orgDetail.city }},
            {{ quickGuideData?.orgDetail.state }},
            {{ quickGuideData?.orgDetail.country }},
            {{ quickGuideData?.orgDetail.zipCode }}
          </div>
        </div>
      </div>

      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
      <div class="heading" style="text-align: center">
        <b
          >Quick Guide To {{ bipLable | reportLabel | async }} For
          {{ quickGuideData?.caseDetail.studentName }}</b
        >
      </div>
      <br />
      <div class="dataValue">
        This guide gives an overview of behavior strategies in place for
        {{ quickGuideData?.caseDetail.studentName }}. For details please refer
        to the complete {{ bipLable | reportLabel | async }}.
      </div>
      <br />
      <div *ngFor="let obj of quickGuideData?.strategyData; let i = index">
        <div>
          <b>{{ obj.title }}</b>
        </div>
        <br />
        <table
          *ngIf="!obj.isEmpty"
          data-pdfmake='{"widths": ["*", "*", "*"], "heights": 20, "layout": {  "hLineColor": "#eaecf0",  "vLineColor": "#eaecf0"}}'>
          <thead>
            <tr>
              <th data-pdfmake='{"marginTop": 5}'>Proactive Strategies</th>
              <th data-pdfmake='{"marginTop": 5}'>Replacement Behavior</th>
              <th data-pdfmake='{"marginTop": 5}'>Reactive Strategies</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let i of getMaxLength(obj)">
              <td>{{ obj.ProactiveStrategy[i] || '' }}</td>
              <td>{{ obj.ReplacementBehavior[i] || '' }}</td>
              <td>{{ obj.ReactiveStrategy[i] || '' }}</td>
            </tr>
          </tbody>
        </table>
        <table
          *ngIf="obj.isEmpty"
          data-pdfmake='{"widths": ["*"], "heights": 10, "layout": { "hLineColor": "#eaecf0", "vLineColor": "#eaecf0"}}'
          style="width: 100%; border-collapse: collapse; text-align: center">
          <tr>
            <td
              style="text-align: center; vertical-align: middle; height: 10px">
              No strategies found.
            </td>
          </tr>
        </table>

        <br />
      </div>
    </div>
  </body>
</html>
